import { extractGroup } from './get-tagged-field-from-string';
import { isDefined } from './is-defined';
export const getFieldGroups = (properties) => {
    if (!isDefined(properties))
        return { common: {}, groups: [] };
    const groupedProperties = Object.entries(properties).reduce((acc, [name, definition]) => {
        var _a;
        var _b;
        const group = extractGroup('group', definition.$comment);
        if (group === '' || group === 'common' || group === 'producer' || group === 'consumer') {
            acc.common[name] = definition;
        }
        else {
            (_a = (_b = acc.groups)[group]) !== null && _a !== void 0 ? _a : (_b[group] = {});
            acc.groups[group][name] = definition;
        }
        return acc;
    }, { common: {}, groups: {} });
    const groupArray = Object.entries(groupedProperties.groups).sort((a, b) => {
        if (a[0] === 'advanced') {
            return 1;
        }
        else if (b[0] === 'advanced') {
            return -1;
        }
        return 0;
    });
    return { common: groupedProperties.common, groups: groupArray };
};
//# sourceMappingURL=get-field-groups.js.map